import { MarketplaceItem } from '../marketplace/models/marketplace-item.model';
import { TicketParkingItem } from '../ticket-parking/models/ticket-parking-item.model';
import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';
import { LottoDetails } from '../lotto/lotto-v2/models/lotto.model';
import { LottoItem } from '../lotto/models/lotto-item.model';
import { MarketplaceBasketCustomFieldModel } from '../marketplace/models/basket/marketplace-basket-customfield.model';

type TransactionItem = MarketplaceItem | LottoDetails | LottoItem | TicketParkingItem | null | undefined;

export interface TransactionSuccessState {
  item: TransactionItem;
  customFields?: MarketplaceBasketCustomFieldModel[]; // Custom fields can come from either marketplace or lotto transactions, so we use a union type here
  quantity: number;
  totalPrice: number;
  orderId: string;
}

const initialState: TransactionSuccessState = {
  item: null,
  quantity: 0,
  totalPrice: 0,
  orderId: '',
  customFields: undefined,
};

export const TransactionSuccessStore = signalStore(
  { providedIn: 'root' },
  withState<TransactionSuccessState>(initialState),
  withMethods((store) => ({
    setTransaction(
      item: TransactionItem,
      quantity: number,
      totalPrice: number,
      customFields?: MarketplaceBasketCustomFieldModel[],
      orderId?: string
    ) {
      patchState(store, { item, quantity, totalPrice, orderId, customFields });
    },
    update(updateFn: (state: TransactionSuccessState) => Partial<TransactionSuccessState>) {
      patchState(store, updateFn);
    },
    reset() {
      patchState(store, initialState);
    },
  }))
);
